import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import CustomVideoPlayer from '../../../src/components/custom-video-player';
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Usage`}</h2>
    <p>{`The box component is a versatile layout component that is intended to simplify the process of adding one-off styles such as padding, margin, background color, and border to (or around) an element.`}</p>
    <p>{`The box provides convenient and comprehensive access to Primer Brand's underlying Primitives, such as the spacing scale and functional design tokens for color and borders.`}</p>
    <p>{`While the box component is highly customizable and can be used to create complex layouts, it is important to use it judiciously and only when necessary.`}</p>
    <h2>{`Options`}</h2>
    <h3>{`Padding`}</h3>
    <p>{`Inner spacing is configurable on all sides or specific directions. Box utilises the CSS padding specification, using logical operators to aid bi-directional reading support.`}</p>
    <p>{`Additionally, fine-grained control over padding at specific viewports is available to ensure optimal, responsive layout on different screen sizes.`}</p>
    <h3>{`Margin`}</h3>
    <p>{`Outer spacing is also configurable on all sides or specific directions. Box utilises the CSS margin specification, similarly using logical operators to aid bi-directional reading support.`}</p>
    <h3>{`Background color`}</h3>
    <p>{`Box enables first-class customisation of its background-color property. Options are limited to background-oriented, functional design tokens such as `}<inlineCode parentName="p">{`default`}</inlineCode>{` and `}<inlineCode parentName="p">{`subtle`}</inlineCode>{`, to ensure maximum color contrast with foreground text.`}</p>
    <h3>{`Border`}</h3>
    <p>{`Box offers various border customisations options, including configuration of `}<inlineCode parentName="p">{`border-style`}</inlineCode>{`, `}<inlineCode parentName="p">{`border-radius`}</inlineCode>{` and `}<inlineCode parentName="p">{`border-colors`}</inlineCode>{`.`}</p>
    <p>{`In most cases, the available options corrospond to border-oriented design tokens available within the system. The exception is border style, which is limited to a subset of the official CSS `}<inlineCode parentName="p">{`border-style`}</inlineCode>{` values.`}</p>
    <h2>{`Accessibility`}</h2>
    <p>{`Box is a purely decorative element by default. It sets no intrinsic roles, ARIA attributes, or keyboard shortcuts.`}</p>
    <p>{`Any interactive content within a box should be given their own appropriate accessibility treatment based on the specific workflow of your application.`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Stack"
        }}>{`Stack`}</a>{`: to enable layout of its immediate children along the vertical or horizontal axis.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/brand/components/Grid"
        }}>{`Grid`}</a>{`: to create flexible and responsive grid-based layouts.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      